import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ScreeningService } from '../services/screening.service';

@Component({
  selector: 'app-applicant-flow-username-set',
  templateUrl: './applicant-flow-username-set.component.html',
  styleUrls: ['./applicant-flow-username-set.component.less']
})
export class ApplicantFlowUsernameSetComponent implements OnInit {
  UserName : string;
  LoginError : boolean;
  ValidationMessage : string;
  NameValid : boolean;
  userNameSet : Subject<string> = new Subject<string>();
  userNameSaveComplete : boolean = false;
  constructor(private routes: Router,private location : Location,private auth: AuthService, private screens: ScreeningService) {
    this.userNameSet.pipe(debounceTime(250),distinctUntilChanged())
    .subscribe(mdl =>{
      this.checkUserName();
      // console.log(`Updating UserName ${mdl}`);
    })
   }

  ngOnInit() {
  }

  triggerUNUpdate(ev : any){
    this.userNameSet.next(this.UserName);
  }

  continue() {
    if(!this.UserName){
      this.LoginError = true;
      this.ValidationMessage = "Please provide a user name";
    }else{
      if(!this.LoginError){
        this.routes.navigateByUrl('/demographics');
      }
    }
  }

  back(){
    this.location.back();
  }

  checkUserName(){
    console.log(`Checking UserName ${this.UserName}`)
    if(!this.UserName || this.UserName == ''){
      this.LoginError = false;
      this.ValidationMessage =  undefined;
      this.NameValid = false;
    }else{
      this.auth.CheckUserName(this.UserName).subscribe((ev: any) =>{
        if(ev.nameExists){
          this.LoginError = true;
          this.ValidationMessage = ev.message;
        }else{
          this.LoginError = false;
          this.NameValid = true;
          this.screens.questions.DataModel.userName = this.UserName;
        }
      })
    }

  }

}
